import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { fetchContent, SiteContent } from "../api/content";

const ContentContext = createContext<SiteContent | null>(null);

export function ContentProvider({ children }: { children: ReactNode }) {
  const [content, setContent] = useState<SiteContent | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchContent()
      .then(setContent)
      .catch(() =>
        setError("Kunne ikke laste innhold. Prøv å laste siden på nytt.")
      );
  }, []);

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
          textAlign: "center",
          px: 2,
        }}
      >
        <Typography color="text.secondary">{error}</Typography>
      </Box>
    );
  }

  if (!content) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return (
    <ContentContext.Provider value={content}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent(): SiteContent {
  const content = useContext(ContentContext);
  if (!content) {
    throw new Error("useContent must be used within a ContentProvider");
  }
  return content;
}
